// FLAG:useDocuAi — split a file name so a too-long name can be shortened WITHOUT losing its
// extension.
//
// The preview title cut the name off at its right edge (`text-overflow: ellipsis` over the whole
// string), so exactly the part that says WHAT you are looking at disappeared first:
// "Herkunftsland_Zolltarif-Nummer__HS___UNSPSC__…" — .xml or .pdf? While reviewing, that is not
// decoration: it is the difference between reading the e-invoice itself and reading a scan of it.

export interface FileNameParts {
  /** Everything before the extension — the part that may be shortened. */
  stem: string
  /** The extension INCLUDING its dot, or '' when the name has none. Never shortened. */
  extension: string
}

// A trailing dot group only counts as an extension when it LOOKS like one: alphanumeric with at
// least one letter, short, at the end, and not at position 0 (dotfiles). "Rechnung vom 12.03.2026"
// therefore keeps its whole name as the stem instead of protecting ".2026" as if it were a suffix.
// Seven characters because receipt upload accepts ".zugferd" (receipt-upload-file-types).
const MAX_EXTENSION_LENGTH = 7
const EXTENSION_PATTERN = /^(?=[a-z0-9]*[a-z])[a-z0-9]+$/i

export const splitFileNameForDisplay = (fileName?: string | null): FileNameParts => {
  const name = fileName || ''
  const dotIndex = name.lastIndexOf('.')
  const suffix = dotIndex > 0 ? name.slice(dotIndex + 1) : ''
  const isExtension = suffix.length <= MAX_EXTENSION_LENGTH && EXTENSION_PATTERN.test(suffix)

  return isExtension
    ? { stem: name.slice(0, dotIndex), extension: name.slice(dotIndex) }
    : { stem: name, extension: '' }
}
